// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
global.toastr = require("toastr")
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

require("jquery");
require("packs/main.js");
require('@popperjs/core');
require('toastr');
require('packs/otp');
require('packs/category');
require('packs/modifiers_condition_check');
require("@fortawesome/fontawesome-free/css/all.css");
require('jquery.blockUI.min.js');
require('parsleyjs');
require('timepicker')
require('packs/order_information');
require('easy-autocomplete');
import 'bootstrap-datepicker'
import "../stylesheets/application";
import "search_item";
import "timepicker/jquery.timepicker.css";
import Swiper, {Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
const images = require.context("../images", true);
window.$ = $;
window.bootstrap = require('bootstrap');
Rails.start()
Turbolinks.start()
ActiveStorage.start()
$(document).on('turbolinks:load', function() {
  $('[data-parsley-validate]').each(function() {
    new Parsley.Factory(this)
  });
  const swiper = new Swiper('.gallry-swiper', {
    modules: [Autoplay, Navigation, Pagination],
    direction: 'horizontal',
    effect: 'slide',
    speed: 400,
    slidesPerView: 5,
    spaceBetween: 20,
    simulateTouch: true,
    loop: true,
    autoplay: {
      delay: 2000,
      stopOnLastSlide: false,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 280px
      280: {
        slidesPerView: 1
      },
      // when window width is >= 541px
      541: {
        slidesPerView: 2
      },
      // when window width is >= 913px
      913: {
        slidesPerView: 3
      },
      // when window width is >= 1281px
      1281: {
        slidesPerView: 3
      }
    }
  });

  const swiperone = new Swiper('.category-swiper', {
    modules: [Autoplay, Navigation, Pagination],
    direction: 'horizontal',
    effect: 'slide',
    speed: 400,
    spaceBetween: 20,
    simulateTouch: true,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 280px
      280: {
        slidesPerView: 1
      },
      // when window width is >= 541px
      541: {
        slidesPerView: 2
      },
      // when window width is >= 913px
      913: {
        slidesPerView: 3
      },
      // when window width is >= 1281px
      1281: {
        slidesPerView: 6
      }
    }
  });

  const swipertwo = new Swiper('.banner-swiper', {
    modules: [Autoplay, Navigation, Pagination],
    fadeEffect: { crossFade: true },
    direction: 'horizontal',
    effect: 'fade',
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 0,
    simulateTouch: true,
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true
    },    
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 280px
      280: {
        slidesPerView: 1
      }
    }
  });
});
$(document).on('click', '.display-cart', function () {
  $('.cart-section').removeClass('d-none');
});
